import { prompt, type PromptDefinition } from './models';

export const FACILITIES_MANAGER_PROMPTS = [
    prompt(
        'Keep it running',
        'Which planned maintenance tasks are due in this building?',
        'Which buildings have the highest-priority planned maintenance due?'
    ),
    prompt(
        'Keep it running',
        'Which service failures are recurring in this building?',
        'Compare recurring service failures across my buildings.'
    ),
    prompt(
        'Coordinate people',
        "Which contractors are responsible for this building's upcoming service work?",
        'Where are contractor responsibilities missing for upcoming work across my buildings?'
    ),
    prompt(
        'Keep it running',
        'Find facilities maintenance plans for this building covering…',
        'Find facilities maintenance plans across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'Which maintenance tasks in this building lack completion evidence?',
        'Which buildings have maintenance completion records to chase first?'
    ),
    prompt(
        'Manage risk',
        'Which safety-system services must be coordinated in this building?',
        'Which buildings need safety-system servicing coordinated this month?'
    ),
    prompt(
        'Keep it running',
        'What critical equipment issues are documented for this building?',
        'Which buildings have critical equipment issues that need escalation?'
    ),
    prompt(
        'Keep it running',
        'Find contractor service reports for this building relating to…',
        'Find contractor service reports across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'What planned shutdowns or access constraints are documented for this building?',
        'Which buildings have shutdown or access constraints affecting planned work?'
    ),
    prompt(
        'Keep it running',
        "What do this building's records say about spare parts and equipment warranties?",
        'Which buildings have parts or warranty information gaps affecting maintenance?'
    ),
    prompt(
        'Understand it',
        "What should go into this building's facilities handover from the available records?",
        'Which buildings have incomplete facilities handover information?'
    ),
    prompt(
        'Keep it running',
        'Help plan maintenance coordination for this building around…',
        'Help prioritise facilities work across my buildings around…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
